var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2424 1.94506C10.1238 1.94481 10.0064 1.96801 9.89681 2.01333C9.78741 2.05858 9.68803 2.12498 9.60436 2.20872C9.60422 2.20886 9.60408 2.20901 9.60393 2.20915L2.03227 9.82276L1.69908 11.4154L3.29094 11.0824L10.8841 3.48927C10.968 3.40551 11.0345 3.30598 11.0799 3.1964C11.1252 3.08682 11.1484 2.96935 11.1481 2.85077L11.1481 2.84963C11.1481 2.60972 11.0528 2.37964 10.8832 2.21C10.7136 2.04036 10.4835 1.94506 10.2436 1.94506L10.2424 1.94506ZM10.2441 0.880863C9.98542 0.880384 9.72914 0.931044 9.49006 1.02993C9.2508 1.12889 9.03347 1.2742 8.85059 1.45749L1.05523 9.29604L0.324219 12.7903L3.81923 12.0591L11.6357 4.24261C11.6356 4.24269 11.6358 4.24253 11.6357 4.24261C11.8189 4.05978 11.9644 3.8423 12.0633 3.60314C12.1621 3.36423 12.2127 3.10816 12.2123 2.84963",
    fill: "#5152C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1851 13.1189H0V12.0547H12.1851V13.1189Z",
    fill: "#5152C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5025 2.55859L10.5351 4.59121L9.78262 5.34371L7.75 3.3111L8.5025 2.55859Z",
    fill: "#5152C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.21b74e8bac30987d22c254df06f4de30.svg";
export { ForwardRef as ReactComponent };